import { removeExtraDecimals } from '@modules/zoom/utils/helpers';
import { Participant, VideoTransmissionQuality } from '@modules/zoom/utils/types';
import { BasicProps } from 'apps/agora/src/utils/types';
import EmptyStateCard from 'apps/agora/src/views/UserView/components/EmptyStateCard';
import InfoItem from './InfoItem';
import ParticipantCard from './ParticipantCard';

interface VideoTabProps extends BasicProps {
  participantsList?: Participant[];
  videoQuality: Record<number, Record<'sending' | 'receiving', VideoTransmissionQuality>>;
  hasEmptyState?: boolean;
}

const VideoTab = (props: VideoTabProps) => {
  const { participantsList, videoQuality, hasEmptyState } = props;

  if (hasEmptyState) {
    return <EmptyStateCard text="No data available." icon={undefined} />;
  }

  return (
    <div className="flex flex-col gap-4">
      {participantsList?.map((user) => (
        <ParticipantCard key={user._id} name={user.fullName}>
          <InfoItem
            label="Average Loss (Sending)"
            value={removeExtraDecimals(videoQuality?.[user.zoomUserId]?.sending?.avgLoss)}
          />
          <InfoItem
            label="Average Loss (Receiving)"
            value={removeExtraDecimals(videoQuality?.[user.zoomUserId]?.receiving?.avgLoss)}
          />
          <InfoItem
            label="Maximum Loss (Sending)"
            value={removeExtraDecimals(videoQuality?.[user.zoomUserId]?.sending?.maxLoss)}
          />
          <InfoItem
            label="Maximum Loss (Receiving)"
            value={removeExtraDecimals(videoQuality?.[user.zoomUserId]?.receiving?.maxLoss)}
          />
          <InfoItem
            label="Resolution (Sending)"
            value={
              videoQuality?.[user.zoomUserId]?.sending?.width
                ? `${videoQuality?.[user.zoomUserId]?.sending?.width} x ${
                    videoQuality?.[user.zoomUserId]?.sending?.height
                  }`
                : 'n/a'
            }
          />
          <InfoItem
            label="Resolution (Receiving)"
            value={
              videoQuality?.[user.zoomUserId]?.receiving?.width
                ? `${videoQuality?.[user.zoomUserId]?.receiving?.width} x ${
                    videoQuality?.[user.zoomUserId]?.receiving?.height
                  }`
                : 'n/a'
            }
          />
          <InfoItem label="FPS (Sending)" value={videoQuality?.[user.zoomUserId]?.sending?.fps} />
          <InfoItem
            label="FPS (Receiving)"
            value={videoQuality?.[user.zoomUserId]?.receiving?.fps}
          />
        </ParticipantCard>
      ))}
    </div>
  );
};

export default VideoTab;
